import { Link as RouterLink } from 'react-router-dom';

export type TableV2LinkRoutingProps =
  | { component: typeof RouterLink; to: string }
  | { href: string };

export const getTableV2LinkRoutingProps = (href: string): TableV2LinkRoutingProps => {
  if (href.startsWith('/')) {
    return { component: RouterLink, to: href };
  }

  return { href };
};
